import React, { useState, useEffect } from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'

import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { listTestimonials } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    // Container,
    devices,
    colors,
    Title,
} from '../Common'

const TestimonialList = ({ list }) => {
    return list.map((t, i) =>
        <>
            <Testimonial key={t.name} color={(i + 1) % 2 === 0 ? colors.red : colors.black}>
                {i === 0 && <PageTitle fontSize={26}>Testimonials</PageTitle>}
                <Text>
                    {t.image && <img src={t.image} />}
                    <Content>{`"${t.content}"`}</Content>
                    <NameAndTitle color={(i + 1) % 2 === 0 ? colors.black : colors.red}>{t.name} / {t.title}</NameAndTitle>
                </Text>
            </Testimonial>
        </>
    )
}

const TestimonialCarousel = ({ testimonials }) => {
    const [activeSlide, setActiveSlide] = useState(0)

    const handleChange = id => setActiveSlide(id)
    return (
        <CarouselContainer>
            <StyledCarousel
                showStatus={false}
                showArrows={false}
                showThumbs={false}
                showIndicators={false}
                infiniteLoop={false}
                stopOnHover={false}
                transitionTime={500}
                autoPlay={false}
                axis={'vertical'}
                onChange={handleChange}
                selectedItem={activeSlide}
                swipeable={true}
                verticalSwipe={'natural'}
            >
                {testimonials.map((t, i) =>
                    <Testimonial key={t.name} color={(i + 1) % 2 === 0 ? colors.red : colors.black}>
                        {i === 0 && <PageTitle fontSize={42}>Testimonials</PageTitle>}
                        <Text>
                            {t.image && <img src={t.image} />}
                            <Content>{`"${t.content}"`}</Content>
                            <NameAndTitle color={(i + 1) % 2 === 0 ? colors.black : colors.red}>{t.name} / {t.title}</NameAndTitle>
                        </Text>
                    </Testimonial>
                )}
            </StyledCarousel>
            <Dots>
                {testimonials.map((t, i) =>
                    <Dot key={i} role='button' onClick={() => setActiveSlide(i)} active={i === activeSlide} aria-label={`Testimonial ${i}`} />
                )}
                <Count>{activeSlide + 1} / {testimonials.length}</Count>
            </Dots>
        </CarouselContainer>
    )
}

const Testimonials = () => {
    const { testimonials } = useSelector(state => state.content, shallowEqual)
    const dispatch = useDispatch()
    const { width } = useWindowSize()
    const mobile = width < 940

    useEffect(() => {
        dispatch(listTestimonials())
    }, [])

    return mobile ? <TestimonialList list={testimonials} /> : <TestimonialCarousel testimonials={testimonials} />

}

const CarouselContainer = styled.div`
    position: relative;
`

const Text = styled.div`
    width: 95%;

    @media ${devices.small} {
        width: 100%;
    }
`

const StyledCarousel = styled(CarouselComp)`
    height: 100vh;
    .carousel-slider {
        height: 100%;
    }

    .slider-wrapper {
        height: 100% !important;
    }

    .slide {
        background: transparent;
    }
`

const PageTitle = styled(Title)`
    position: absolute;
    top: 50px;
    @media ${devices.small} {
        top: 30px;
    }
`

const Testimonial = styled.div`
    background: ${({ color }) => color};
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 100px;

    img {
        width: 150px !important;
        height: 150px;
        border-radius: 50%;
    }
    
    @media ${devices.small} {
        position: relative;
        padding: 30px 20px;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        /* height: 87vh; */
        height: calc(95vh - 60px);
        
        img {
            width: 80px !important;
            height: 80px;
            margin-bottom: 40px;
        }
    }
`

const Content = styled.div`
    color: ${colors.white};
    font-size: 30px;
    font-family: pragmatica, sans-serif;
    font-weight: 900;
    font-style: normal;
    text-align: left;
    margin-bottom: 50px;

    @media ${devices.small} {
        font-size: 18px;
    }
`

const NameAndTitle = styled.div`
    text-transform: uppercase;
    color: ${({ color }) => color};
    font-size: 15px;
    font-family: pragmatica, sans-serif;
    font-weight: 700;
    font-style: normal;
    text-align: left;
    letter-spacing: 2px;

    @media ${devices.small} {
        font-size: 8px;
        line-height: 1.5;
    }
`

const Dots = styled.div`
    margin-top: 20px;
    text-align: center;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    position: absolute;
    top: 40%;
    right: 25px;

    @media ${devices.small} {
        display: none;
    }
`

const Dot = styled.div`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 16px;
    margin-bottom: 17px;
    background: ${colors.white};
    opacity: ${({ active }) => active ? 1 : 0.5};
    cursor: pointer;
`

const Count = styled.div`
    color: ${colors.white};
    font-family: pragmatica, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 8px;
`

export default Testimonials